import React, { useEffect, useState, useContext } from "react";
import { ScreenSizeContext } from "../context/ScreenSizeContext";
import { useHistory } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import EmailIcon from "@material-ui/icons/Mail";
import PhoneIcon from "@material-ui/icons/Phone";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import IconButton from "@material-ui/core/IconButton";
import Rating from "@material-ui/lab/Rating";
import CircularProgress from "@material-ui/core/CircularProgress";
import { AuthContext } from "../context/AuthContext";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import PrintConsultantPage from "./printableComponents/PrintConsultantPage";
import "../styles/printStyles.css";
import sortDatesDesc from "../genericFunctions/sortDatesDesc";
import getProfilePictureSource from "../genericFunctions/getProfilePictureSource";
import PublicService from "../services/PublicService";
import sortDatesIncludingPresent from "../genericFunctions/sortDatesIncludingPresent";
import getDisplayContactInfo from "../genericFunctions/getDisplayContactInfo";
import getDisplayTranslation from "../genericFunctions/getDisplayTranslation";
import getProfileLabel from "../genericFunctions/getProfileLabel";
import { getProfileLanguageName } from "../genericFunctions/profileLanguages";
import { getProficiencyLabel, sortLanguagesByProficiency } from "../genericFunctions/languageProficiencies";

const ConsultantPage = (props) => {
  const { id } = props.match.params;
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const { onMobile } = useContext(ScreenSizeContext);
  const [loading, setLoading] = useState(true);
  const [consultant, setConsultant] = useState({ username: "" });
  const [managerInfo, setManagerInfo] = useState({ username: "" });
  const [managerResume, setManagerResume] = useState(true);
  const [anonymousProfile, setAnonymousProfile] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(null);

  const isAdmin = authContext.user.role.includes("admin");
  const translations = consultant.translations || [];
  const translation = getDisplayTranslation(translations, selectedLanguage);
  const language = translation ? translation.language : "en";
  const label = (key) => getProfileLabel(language, key);

  const printView = () => {
    const printableElements = document.getElementById("printme").innerHTML;

    const printHtml =
      "<html><head><title></title></head><body>" +
      printableElements +
      "</body></html>";
    const oldPage = document.body.innerHTML;
    document.body.innerHTML = printHtml;
    window.print();
    document.body.innerHTML = oldPage;
    window.location.reload();
  };

  const toVersionManager = () => {
    history.push(`/versionmanager/${id}`);
  };

  const toConsultantEditor = () => {
    history.push(`/consultanteditor/${id}`);
  };

  useEffect(() => {
    const getManager = (managerId) => {
      PublicService.getConsultant(managerId).then((data) => {
        if (data && data.user) {
          setManagerInfo(data.user);
        }
      });
    };

    PublicService.getConsultant(id).then((data) => {
      if (data && data.user) {
        setConsultant(data.user);
        setAnonymousProfile(data.user.privateResume);
        if (data.user.manager) {
          getManager(data.user.manager);
        }
        setLoading(false);
      }
    });
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  const roles = [...((translation && translation.roles) || [])].sort(
    (a, b) => b.stars - a.stars
  );
  const skills = [...((translation && translation.skills) || [])].sort(
    (a, b) => b.stars - a.stars
  );
  const languages = sortLanguagesByProficiency(
    (translation && translation.languages) || []
  );
  const hobbies = (translation && translation.hobbies) || [];
  const experiences = [...((translation && translation.experiences) || [])].sort(
    (a, b) => sortDatesIncludingPresent(a.toDate, b.toDate)
  );
  const educations = [...((translation && translation.educations) || [])].sort(
    (a, b) => sortDatesDesc(new Date(a.fromDate), new Date(b.fromDate))
  );

  const { displayEmail, displayPhone } = getDisplayContactInfo(
    anonymousProfile,
    managerResume,
    consultant.email,
    managerInfo.email,
    consultant.phone,
    managerInfo.phone
  );

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      {loading && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "15%",
          }}
        >
          <CircularProgress color="secondary" />
        </div>
      )}
      {!loading && (
        <Paper style={{ width: !onMobile ? "85%" : "100%" }}>
          <div
            style={{
              backgroundColor: "#13222D",
              padding: "20px",
              borderTopLeftRadius: "5px",
              borderTopRightRadius: "5px",
              display: "flex",
              alignItems: "center",
              flexDirection: onMobile ? "column" : "",
            }}
          >
            <img
              alt=""
              src={getProfilePictureSource(
                anonymousProfile,
                consultant.profilePic
              )}
              style={{
                objectFit: "cover",
                width: "150px",
                height: "150px",
                borderRadius: "50%",
                boxShadow: "0px 1px 16px -4px rgba(0,0,0,0.75)",
                border: " 2px solid #13222D",
                position: "relative",
                top: "0",
                left: "0",
              }}
            />
            <div
              style={{ color: "white", marginLeft: "10px", flexShrink: 0 }}
            >
              <h2>
                {consultant.firstname && !anonymousProfile
                  ? `${consultant.firstname} ${consultant.lastname}`
                  : anonymousProfile
                  ? label("anonymous")
                  : label("noName")}
              </h2>
              <h5 style={{ marginBottom: "5px" }}>
                {translation && translation.title}
              </h5>
              <div
                style={{
                  display: "flex",
                  marginTop: "10px",
                  alignItems: "center",
                }}
              >
                <EmailIcon fontSize="small" />
                <p style={{ marginBottom: "0px", marginLeft: "5px" }}>
                  {displayEmail || label("noEmail")}
                  {managerResume && " (manager email)"}
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  marginTop: "10px",
                  alignItems: "center",
                }}
              >
                <PhoneIcon fontSize="small" />
                <p style={{ marginBottom: "0px", marginLeft: "5px" }}>
                  {displayPhone || label("noPhone")}
                  {managerResume && " (manager phone)"}
                </p>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <LocationCityIcon fontSize="small" />
                <p style={{ margin: "2px 5px" }}>
                  {consultant.officeLocation
                    ? consultant.officeLocation
                    : label("noLocation")}
                </p>
              </div>
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                height: !onMobile
                  ? "150px"
                  : onMobile && isAdmin
                  ? "170px"
                  : "50px",
              }}
            >
              {isAdmin && (
                <>
                  <Button
                    type="button"
                    variant="outlined"
                    style={{
                      color: "white",
                      border: "1px solid white",
                      alignSelf: onMobile ? "center" : "flex-end",
                    }}
                    onClick={toConsultantEditor}
                  >
                    Edit master profile
                  </Button>
                  <Button
                    type="button"
                    variant="outlined"
                    style={{
                      color: "white",
                      border: "1px solid white",
                      alignSelf: onMobile ? "center" : "flex-end",
                      marginTop: "5px",
                    }}
                    onClick={toVersionManager}
                  >
                    Manage versions
                  </Button>
                </>
              )}
              <div
                style={{
                  color: "white",
                  display: "flex",
                  justifyContent: !onMobile ? "flex-end" : "center",
                  width: "100%",
                  alignItems: "flex-end",
                  marginTop: onMobile ? "10px" : "",
                  alignSelf: "flex-end",
                  justifySelf: "flex-end",
                  flexWrap: "wrap",
                }}
              >
                {translations.length > 1 &&
                  translations.map((translationTab) => (
                    <Button
                      key={translationTab.language}
                      type="button"
                      size="small"
                      style={{
                        color: "white",
                        border:
                          translationTab.language === language
                            ? "1px solid white"
                            : "1px solid transparent",
                        margin: "0px 5px 1px 0px",
                      }}
                      onClick={() =>
                        setSelectedLanguage(translationTab.language)
                      }
                    >
                      {getProfileLanguageName(translationTab.language)}
                    </Button>
                  ))}
                {isAdmin && (
                  <>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={anonymousProfile}
                          onChange={(_event, checked) =>
                            setAnonymousProfile(checked)
                          }
                          name="anonymousProfile"
                          value={anonymousProfile}
                          style={{
                            color: "white",
                            padding: "0px 10px",
                            marginTop: "-2px",
                          }}
                        />
                      }
                      label="Anonymous"
                      style={{
                        padding: "10px 2px 5px",
                        marginBottom: "0px",
                      }}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={managerResume}
                          onChange={(_event, checked) =>
                            setManagerResume(checked)
                          }
                          name="managerResume"
                          value={managerResume}
                          style={{
                            color: "white",
                            padding: "0px 10px",
                            marginTop: "-2px",
                          }}
                        />
                      }
                      label="Manager"
                      style={{
                        padding: "10px 2px 5px",
                        marginBottom: "0px",
                      }}
                    />
                  </>
                )}
                {isAdmin && (
                  <>
                    <IconButton
                      variant="outlined"
                      style={{
                        marginRight: "20px",
                        color: "white",
                        padding: "0px 0px 6px 0px",
                      }}
                      onClick={printView}
                    >
                      <PictureAsPdfIcon />
                    </IconButton>
                  </>
                )}
                <div style={{ display: "flex", alignItems: "flex-end" }}>
                  <h6>Availability</h6>
                  <p
                    style={{
                      border: consultant.availible
                        ? "1px solid green"
                        : "1px solid red",
                      borderRadius: "50%",
                      width: "10px",
                      height: "10px",
                      backgroundColor: consultant.availible
                        ? "lightgreen"
                        : "red",
                      margin: "0px 0px 13px 5px",
                    }}
                  ></p>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              padding: "20px",
              display: "flex",
              flexDirection: onMobile ? "column" : "row",
            }}
          >
            <div
              style={{
                width: !onMobile ? "70%" : "100%",
                borderRight: !onMobile ? "1px solid #e1e1e1" : "",
                paddingRight: "20px",
              }}
            >
              <h3>{label("presentation")}</h3>
              <p style={{ whiteSpace: "pre-wrap" }}>
                {translation && translation.presentation
                  ? translation.presentation
                  : label("noPresentation")}
              </p>
              {!onMobile && (
                <div style={{ margin: "30px 0px" }}>
                  <h4 style={{ paddingBottom: "5px" }}>
                    {label("experiences")}
                  </h4>
                  {experiences.length <= 0 ? (
                    <p>{label("noExperiences")}</p>
                  ) : (
                    experiences.map((experience) => (
                        <div
                          key={experience._id}
                          style={{
                            borderBottom:
                              experience !== experiences[experiences.length - 1]
                                ? "1px solid #e1e1e1"
                                : "",
                            padding: "0px",
                            marginBottom: "20px",
                          }}
                        >
                          <div style={{ marginBottom: "10px" }}>
                            <h6>{experience.name}</h6>
                            <p
                              style={{
                                fontStyle: "italic",
                                color: "dark-grey",
                                fontSize: "90%",
                                margin: "5px 0px 0px 0px",
                              }}
                            >
                              {`${experience.role} (${
                                experience.fromDate !== null
                                  ? experience.fromDate.slice(0, 7)
                                  : label("missingDate")
                              } - ${
                                experience.toDate !== null
                                  ? experience.toDate.slice(0, 7)
                                  : label("present")
                              })`}
                            </p>
                          </div>
                          <p style={{ whiteSpace: "pre-wrap" }}>
                            {experience.description}
                          </p>
                          <p style={{ fontWeight: "bold", margin: "0px" }}>
                            {label("tools")}
                          </p>
                          <p>{experience.tools}</p>
                        </div>
                      ))
                  )}
                </div>
              )}
            </div>
            <div style={{ width: !onMobile ? "40%" : "100%" }}>
              <div style={{ marginLeft: !onMobile ? "20px" : "0px" }}>
                <h4>{label("roles")}</h4>
                {roles.length <= 0 ? (
                  <p>{label("noRoles")}</p>
                ) : (
                  roles.map((role) => (
                    <div
                      style={{ display: "flex", alignItems: "center" }}
                      key={role._id}
                    >
                      <p>{role.name}</p>
                      <Rating
                        value={parseInt(role.stars)}
                        readOnly
                        style={{ marginBottom: "18px", marginLeft: "5px" }}
                      />
                    </div>
                  ))
                )}
              </div>
              <div style={{ marginLeft: !onMobile ? "20px" : "0px" }}>
                <h4>{label("skills")}</h4>
                {skills.length <= 0 ? (
                  <p>{label("noSkills")}</p>
                ) : (
                  skills.map((skill) => (
                    <div
                      style={{ display: "flex", alignItems: "center" }}
                      key={skill._id}
                    >
                      <p>{skill.name}</p>
                      <Rating
                        value={parseInt(skill.stars)}
                        readOnly
                        style={{ marginBottom: "18px", marginLeft: "5px" }}
                      />
                    </div>
                  ))
                )}
              </div>
              <div
                style={{
                  marginLeft: !onMobile ? "20px" : "0px",
                  marginTop: "20px",
                }}
              >
                <h4>{label("languages")}</h4>
                {languages.length <= 0 ? (
                  <p>{label("noLanguages")}</p>
                ) : (
                  languages.map((spokenLanguage) => (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        alignContent: "space-between",
                      }}
                      key={spokenLanguage._id}
                    >
                      <p>{spokenLanguage.name}: </p>&nbsp;&nbsp;
                      <p>
                        {getProficiencyLabel(
                          spokenLanguage.proficiency,
                          language
                        )}
                      </p>
                    </div>
                  ))
                )}
              </div>
              <div
                style={{
                  marginLeft: !onMobile ? "20px" : "0px",
                  marginTop: "20px",
                }}
              >
                <h4>{label("hobbies")}</h4>
                {hobbies.length <= 0 ? (
                  <p>{label("noHobbies")}</p>
                ) : (
                  hobbies.map((hobby) => <p key={hobby._id}>{hobby.name}</p>)
                )}
              </div>
              {onMobile && (
                <div style={{ margin: "30px 0px" }}>
                  <h4 style={{ paddingBottom: "5px" }}>
                    {label("experiences")}
                  </h4>
                  {experiences.length <= 0 ? (
                    <p>{label("noExperiences")}</p>
                  ) : (
                    experiences.map((experience) => (
                        <div
                          style={{
                            borderBottom:
                              experience !== experiences[experiences.length - 1]
                                ? "1px solid #e1e1e1"
                                : "",
                            padding: "0px",
                            marginBottom: "20px",
                          }}
                          key={experience._id}
                        >
                          <div style={{ marginBottom: "10px" }}>
                            <h6>{experience.name}</h6>
                            <p
                              style={{
                                fontStyle: "italic",
                                color: "dark-grey",
                                fontSize: "90%",
                                margin: "5px 0px 0px 0px",
                              }}
                            >{`${
                              experience.fromDate !== null
                                ? experience.fromDate.slice(0, 7)
                                : label("missingDate")
                            }
                                -
                              ${
                                experience.toDate !== null
                                  ? experience.toDate.slice(0, 7)
                                  : label("present")
                              }`}</p>
                          </div>
                          <p style={{ whiteSpace: "pre-wrap" }}>
                            {experience.description}
                          </p>
                          <p style={{ fontWeight: "bold", margin: "0px" }}>
                            {label("tools")}
                          </p>
                          <p>{experience.tools}</p>
                        </div>
                      ))
                  )}
                </div>
              )}
              <div
                style={{
                  marginLeft: !onMobile ? "20px" : "0px",
                  marginTop: "40px",
                  maxWidth: "100%",
                }}
              >
                <h4 style={{ paddingBottom: "5px" }}>{label("education")}</h4>
                {educations.length <= 0 ? (
                  <p>{label("noEducations")}</p>
                ) : (
                  educations.map((education) => (
                    <div
                      style={{
                        borderBottom:
                          education !== educations[educations.length - 1]
                            ? "1px solid #e1e1e1"
                            : "",
                        padding: "0px",
                        marginBottom: "20px",
                      }}
                      key={education._id}
                    >
                      <div style={{ marginBottom: "10px" }}>
                        <h6>{education.name}</h6>
                        <p
                          style={{
                            fontStyle: "italic",
                            color: "dark-grey",
                            fontSize: "90%",
                            margin: "5px 0px 0px 0px",
                          }}
                        >{`${
                          education.fromDate !== null
                            ? education.fromDate.slice(0, 7)
                            : label("missingDate")
                        }
                              -
                              ${
                              education.toDate !== null
                                ? education.toDate.slice(0, 7)
                                : label("present")
                            }`}</p>
                      </div>
                      <p>{education.school}</p>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>

          {
            <PrintConsultantPage
              printableId="printme"
              language={language}
              anonymousProfile={anonymousProfile}
              managerResume={managerResume}
              consultantProfilePic={consultant.profilePic}
              consultantEmail={consultant.email}
              consultantPhoneNo={consultant.phone}
              consultantFirstname={consultant.firstname}
              consultantLastName={consultant.lastname}
              consultantTitle={translation && translation.title}
              managerInfo={managerInfo}
              presentation={translation && translation.presentation}
              skills={skills}
              roles={roles}
              educations={educations}
              hobbies={hobbies}
              languages={languages}
              experiences={experiences}
            />
          }
        </Paper>
      )}
    </div>
  );
};

export default ConsultantPage;
